import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { Notification } from '@notifications/models/notification';

@Injectable()
export class AttachmentsZipService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiUrl = `${ENVIRONMENT.qApi.endpoint}`;

  downloadInspectionAttachments(
    inspectionId: number
  ): Observable<Notification> {
    return this.#httpClient.get<Notification>(
      `${this.#apiUrl}/inspection/${inspectionId}/download-attachments`
    );
  }

  downloadInspectionItemAttachments(
    inspectionId: number,
    inspectionItemId: number
  ): Observable<Notification> {
    return this.#httpClient.get<Notification>(
      `${this.#apiUrl}/inspection/${inspectionId}/item/${inspectionItemId}/download-attachments`
    );
  }

  downloadLopItemAttachments(lopItemId: number): Observable<Notification> {
    return this.#httpClient.get<Notification>(
      `${this.#apiUrl}/lopItem/${lopItemId}/download-attachments`
    );
  }
}
